export const getHotspotsData = ({ componentData, sourceData }) => {

  if (componentData) {
    const hotspots = componentData?.hotspots ? JSON.parse(componentData.hotspots) : null;
    const hotspotArr = hotspots?.hotspots ? hotspots.hotspots.reverse() : null;
    const actions = componentData?.hotspotActions || [];

    return { hotspotArr, actions };
  }
  if (sourceData && sourceData?.hotspot) {
    const hotspots = sourceData?.hotspot ? JSON.parse(sourceData?.hotspot) : [];

    if (!Array.isArray(hotspots)) {
      return { hotspotArr: [], actions: [] };
    }

    const actions = hotspots.map((hotspot) => {
      if (hotspot.action) {
        return hotspot.action;
      }
      return null;
    });

    return { hotspotArr: hotspots, actions };
  }

  return { hotspotArr: [], actions: [] };
};